














import { ACTION_SET_TWILIO_CHAT_MAIN_WINDOW } from '@/store/modules/twilio';
import EventsBus from '@/services/eventbus';
import ChatContainer from './chatContainer.vue';

export default {
    components: {
        ChatContainer,
    },

    data(this: any) {
        return {
            theme: 'light',
        };
    },
    computed: {
        currentUserId(this: any) {
            return this.$store.getters.getTwilioUser.Identity;
        },
    },
    mounted(this: any) {
        this.$store.dispatch(ACTION_SET_TWILIO_CHAT_MAIN_WINDOW, true);
    },
    async destroyed(this: any) {
        await this.$store.dispatch(ACTION_SET_TWILIO_CHAT_MAIN_WINDOW, false);
    },
};
